import React from 'react'
import mainImage from '../../assets/about.svg'
import { Container, Title, Hr, Wrapper, LeftColumn, RightColumn, Header, Text, Bold, Image } from './AboutElements'

const About = () => {
    return (
        <Container id="about">
            <Title>About</Title>
            <Hr></Hr>
            <Wrapper>
                <LeftColumn>
                    <Image src={mainImage} alt="woman sitting near the huge smartphone" />
                </LeftColumn>
                <RightColumn>

                    <Text> As a former English teacher, I've always been passionate about clear and effective communication. Now, as an email developer,
                        I'm excited to apply that passion to creating engaging and impactful campaigns. With proficiency
                        in <Bold>HTML, CSS,</Bold> and <Bold>JavaScript,</Bold> and experience using design tools
                        like <Bold>Adobe Photoshop, Figma,</Bold> and <Bold>Canva,</Bold> I'm able to bring a unique blend of technical and creative skills to my work. </Text>


                    <Text> In addition to my technical skills, I am a creative problem-solver who enjoys collaborating with others to achieve common goals.
                        I am constantly learning and striving to improve my craft, and I am excited about the opportunities that lie ahead in the world of email development.</Text>

                    <Text> If you are looking for a dedicated, hardworking email developer who is passionate about creating engaging, effective emails,
                        please don't hesitate to get in touch. I would love to hear more about your project and how I can help bring your vision to life.
                    </Text>

                </RightColumn>

            </Wrapper>
        </Container>
    )
}

export default About
